export default "__VITE_ASSET__BvMzzlp$__"